<h2 mat-dialog-title>Import DNPE List</h2>

<mat-dialog-content>
  @if (phase === 'idle') {
    <p>Upload the DNPE weekly private school Excel file (.xlsx) to update the list.</p>
    <div class="choose-file-row">
      <button mat-raised-button color="primary" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
        Choose File (.xlsx)
      </button>
      <input #fileInput type="file" accept=".xlsx" class="file-input" (change)="onFileSelected($event)" />
    </div>
    @if (xlsxError) {
      <p class="error-text">{{ xlsxError }}</p>
    }
  }

  @if (phase === 'processing') {
    <p>Processing file, please wait…</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (phase === 'done') {
    <mat-progress-bar mode="determinate" value="100"></mat-progress-bar>

    @if (importError) {
      <p class="error-text"><mat-icon>error</mat-icon> {{ importError }}</p>
    }

    @if (result) {
      <div class="result-summary">
        <mat-icon class="result-icon">{{ hasErrors ? 'warning' : 'check_circle' }}</mat-icon>
        <ul class="result-stats">
          <li><strong>{{ result.totalRows }}</strong> total rows</li>
          <li><strong>{{ result.insertedCount }}</strong> inserted</li>
          <li><strong>{{ result.updatedCount }}</strong> updated</li>
          <li><strong>{{ result.unchangedCount }}</strong> unchanged</li>
          <li><strong>{{ result.matchedCount }}</strong> matched to K12 schools</li>
          <li><strong>{{ result.errors.length }}</strong> errored</li>
        </ul>
      </div>
      @if (hasErrors) {
        <p class="error-heading">Row errors:</p>
        <textarea readonly class="error-log">{{ errorText }}</textarea>
      }
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (phase === 'idle' || phase === 'processing') {
    <button mat-button mat-dialog-close [disabled]="phase === 'processing'">Cancel</button>
  }
  @if (phase === 'done') {
    <button mat-raised-button color="primary" (click)="closeAndRefresh()">Close</button>
  }
</mat-dialog-actions>
